// const con = document.querySelector('.onq')
// const imgs = document.querySelectorAll('img')
// con.addEventListener('scroll',()=>{
// 	imgs.forEach(img=>{
// 		const imgTop = img.getBoundingClientRect().top
// 		const conTop = con.getBoundingClientRect().top
// 		if(imgTop-conTop<=con.clientHeight){
// 			const src = img.getAttribute('data-src')
// 			img.setAttribute('src',src)
// 			img.classList.add('fade')
// 		}
// 	})
// })
start();
	$(window).on('scroll', function() {
	start();
	})
	
	function start() {
	$('.container img').not('[data-isLoaded]').each(function() {
	var $node = $(this);
	if (isShow($node)) {
	loadImg($node);
	}
	})
	}
	
	function isShow($node) {
	return $node.offset().top <= $(window).height() + $(window).scrollTop();
	}
	function loadImg($img) {
	$img.attr('src', $img.attr('data-src'));
	$img.attr('data-isLoaded', 1); 
	}